import { render, staticRenderFns } from "./ErrorRecordControl.vue?vue&type=template&id=c46c957a&scoped=true"
import script from "./ErrorRecordControl.vue?vue&type=script&lang=js"
export * from "./ErrorRecordControl.vue?vue&type=script&lang=js"
import style0 from "./ErrorRecordControl.vue?vue&type=style&index=0&id=c46c957a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46c957a",
  null
  
)

export default component.exports